import '@/libs/global'

import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import env from '@/env'
import '@/styles/app.scss'
import '@/plugins/element'
import '@c'
import '@/icons'
import '@/directives'

import VueAMap from 'vue-amap'

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
    key: env.AMap.key,
    // eslint-disable-next-line standard/array-bracket-even-spacing
    plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.MouseTool', 'AMap.Geolocation', 'AMap.StyleObject', 'AMap.Size', 'AMap.Pixel', 'AMap.MassMarks', 'AMap.Heatmap'],
    uiVersion: '1.0.11', // ui库版本，不配置不加载,
    v: '1.4.4',
})

// lazyAMapApiLoaderInstance.load().then(() => {
//   // your code ...
//   this.map = new AMap.Map('amapContainer', {
//     center: new AMap.LngLat(121.59996, 31.197646),
//   })
// })
Vue.config.productionTip = false

// 手动维护的该字段，在 activated 中变为 true 的时机，
// 会比 watch 执行的时机要晚，所以可以在组件被缓存时，不执行特定的 watch
// 在 watch 中加入 if (!this.$active) return 即可
Vue.mixin({
  beforeCreate() {
    this.$active = true
  },
  deactivated() {
    this.$active = false
  },
  activated() {
    this.$active = true
  },
})

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#admin-app')

if (process.env.NODE_ENV === 'development') {
  window.app = app
}
